module.exports = __webpack_public_path__ + "img/arn.50eb11e8.svg";